var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchresultImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#ECECEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5807 36.6644C34.1916 36.6644 35.4974 35.3586 35.4974 33.7477C35.4974 32.1369 34.1916 30.8311 32.5807 30.8311C30.9699 30.8311 29.6641 32.1369 29.6641 33.7477C29.6641 35.3586 30.9699 36.6644 32.5807 36.6644Z",
    stroke: "#263238",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6818 26.166H23.8333C23.2145 26.166 22.621 26.4118 22.1834 26.8494C21.7458 27.287 21.5 27.8805 21.5 28.4993V38.9994C21.5 39.6182 21.7458 40.2117 22.1834 40.6493C22.621 41.0869 23.2145 41.3327 23.8333 41.3327H40.1667C40.7855 41.3327 41.379 41.0869 41.8166 40.6493C42.2542 40.2117 42.5 39.6182 42.5 38.9994V30.8327",
    stroke: "#263238",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 25H42.5",
    stroke: "#263238",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 21.5V28.5",
    stroke: "#263238",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchresultImageIcon);
export default __webpack_public_path__ + "static/media/searchresultImageIcon.01c3ce4c.svg";
export { ForwardRef as ReactComponent };